import { useState, useEffect ,useRef } from "react";
import axios from "axios";
import "./MiPerfil.css";
import API from "../api";
import { Form, Button, Row, Col , Modal } from "react-bootstrap";

const MiPerfil = () => {
  const [usuario, setUsuario] = useState(null);
  const [pestanaActiva, setPestanaActiva] = useState("info");
  const [solicitudes, setSolicitudes] = useState([]);
  const [tiposSolicitud, setTiposSolicitud] = useState([]);
  const [tipo, setTipo] = useState("Vacaciones");
  const [paginaActual, setPaginaActual] = useState(1);
  const solicitudesPorPagina = 7;
  const totalPaginas = Math.ceil(solicitudes.length / solicitudesPorPagina);
  const indiceInicio = (paginaActual - 1) * solicitudesPorPagina;
  const indiceFin = indiceInicio + solicitudesPorPagina;
  const solicitudesPaginadas = solicitudes.slice(indiceInicio, indiceFin);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [comentario, setComentario] = useState("");
  const [estructuraOrganigrama, setEstructuraOrganigrama] = useState([]);
  const [jefeDirecto, setJefeDirecto] = useState(null);

  const [subiendo, setSubiendo] = useState(false);
  const [eliminando, setEliminando] = useState(false);
  const fileInputRef = useRef(null);

  const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false);
  const [archivoAEliminar, setArchivoAEliminar] = useState(null);

  useEffect(() => {
    axios.get(`${API}/estructura_organigrama`)
      .then((res) => {
        if (res.data.exito) {
          setEstructuraOrganigrama(res.data.estructura);
          console.log("Estructura organigrama:", estructuraOrganigrama);
        }
      })
      .catch((err) => console.error("Error al obtener estructura:", err));
  }, []);

  const obtenerJefeDirecto = (usuarioActivo, estructura) => {
    if (!usuarioActivo || estructura.length === 0) return;

    console.log("👤 Usuario activo:", usuarioActivo.Usuario);

    // Buscar nodo en organigrama usando el campo 'Usuario'
    const nodo = estructura.find(n =>
      String(n.Usuario) === String(usuarioActivo.Usuario)
    );

    console.log("📌 Nodo encontrado por Usuario:", nodo);

    if (!nodo || !nodo.padre_id) {
      console.log("⛔ Este usuario no tiene jefe directo asignado.");
      if (jefeDirecto !== null) setJefeDirecto(null);
      return;
    }

    // Buscar jefe usando usuario_id === padre_id
    const jefe = estructura.find(n =>
      String(n.usuario_id) === String(nodo.padre_id)
    );

    console.log("✅ Jefe encontrado:", jefe);

    const nombreJefe = jefe?.nombre || null;

    if (jefeDirecto !== nombreJefe) {
      console.log("🆕 Actualizando jefe directo:", nombreJefe);
      setJefeDirecto(nombreJefe);
    }
  };

  useEffect(() => {
    if (usuario && estructuraOrganigrama.length > 0) {
      console.log("Buscando jefe directo...");
      obtenerJefeDirecto(usuario, estructuraOrganigrama);
    }
  }, [usuario, estructuraOrganigrama]);

  useEffect(() => {
    const datos = sessionStorage.getItem("usuarioActivo");
    if (datos) {
      const parsed = JSON.parse(datos);
      setUsuario(parsed);
      obtenerSolicitudes(parsed.Usuario);
    }
  }, []);

  const [documentos, setDocumentos] = useState([]);
  const [rutaCarpeta, setRutaCarpeta] = useState("");

  useEffect(() => {
    const usuarioActivo = JSON.parse(sessionStorage.getItem("usuarioActivo"));
    if (!usuarioActivo) return;

    const carpeta = `${usuarioActivo.Nombre}_${usuarioActivo["Apellido Paterno"]}_${usuarioActivo["Apellido Materno"]}`;

    axios.get(`${API}/documentos_usuario/${carpeta}`)
      .then((res) => {
        if (res.data.exito) {
          setDocumentos(res.data.documentos);
          setRutaCarpeta(carpeta);  // importante: no la ruta física
        }
      })
      .catch((err) => console.error("Error al obtener documentos:", err));
  }, []);


  const calcularVacaciones = (fechaIngresoStr, solicitudesUsuario = []) => {
    if (!fechaIngresoStr) return 0;

    // Parsear fecha desde formato "dd/mm/yyyy"
    const [dia, mes, anio] = fechaIngresoStr.split("/");
    const fechaIngreso = new Date(`${anio}-${mes}-${dia}`);
    const hoy = new Date();

    const totalMeses = (hoy.getFullYear() - fechaIngreso.getFullYear()) * 12 + (hoy.getMonth() - fechaIngreso.getMonth());
    // const acumuladas = Math.floor(totalMeses * 1.25);
    const acumuladas = Math.ceil(totalMeses * 1.25);
    // Asegurarse que solicitudesUsuario es un array
    const diasTomados = (solicitudesUsuario || [])
      .filter(s => s.Estado === "Aprobado" && s.TipoSolicitud === "Vacaciones")
      .reduce((total, s) => total + contarDiasHabiles(s.FechaInicio, s.FechaFin), 0);

    return acumuladas - diasTomados;
  };

  const contarDiasHabiles = (inicioStr, finStr) => {
    const [diaI, mesI, anioI] = inicioStr.split("/");
    const [diaF, mesF, anioF] = finStr.split("/");

    const inicio = new Date(`${anioI}/${mesI}/${diaI}`);
    const fin = new Date(`${anioF}/${mesF}/${diaF}`);

    let diasHabiles = 0;
    for (let d = new Date(inicio); d <= fin; d.setDate(d.getDate() + 1)) {
      const diaSemana = d.getDay();
      if (diaSemana !== 0 && diaSemana !== 6) diasHabiles++; // Lunes a viernes
    }

    return diasHabiles;
  };

  const obtenerSolicitudes = async (usuario) => {
    try {
      const res = await axios.get(`${API}/solicitudes_rrhh/${usuario}`);

      const ordenadas = res.data.sort((a, b) => {
        const fechaA = a.FechaSolicitud
          ? new Date(a.FechaSolicitud.split("/").reverse().join("-"))
          : new Date(0); // muy antiguo
        const fechaB = b.FechaSolicitud
          ? new Date(b.FechaSolicitud.split("/").reverse().join("-"))
          : new Date(0);

        return fechaB - fechaA; // más recientes primero
      });

      setSolicitudes(ordenadas);
    } catch (err) {
      console.error("Error al obtener solicitudes:", err);
    }
  };

  useEffect(() => {
    axios.get(`${API}/tipos_solicitud`)
      .then((res) => {
        if (res.data.exito) {
          setTiposSolicitud(res.data.tipos);
        }
      })
      .catch((err) => {
        console.error("Error al obtener tipos de solicitud:", err);
      });
  }, []);

  const formatearFecha = (fechaStr) => {
    if (!fechaStr) return "";
    const [anio, mes, dia] = fechaStr.split("-");
    return `${dia}/${mes}/${anio}`;
  };

  const obtenerFechaHoy = () => {
    const hoy = new Date();
    const dia = String(hoy.getDate()).padStart(2, "0");
    const mes = String(hoy.getMonth() + 1).padStart(2, "0");
    const anio = hoy.getFullYear();
    return `${dia}/${mes}/${anio}`;
  };

  const enviarSolicitud = async (e) => {
    e.preventDefault();
    if (!usuario) return;

    const diasDisponibles = calcularVacaciones(usuario.FechaIngreso, solicitudes);
    const diasSolicitados = contarDiasHabiles(formatearFecha(fechaInicio), formatearFecha(fechaFin));

    if (diasSolicitados > diasDisponibles) {
      alert("No cuenta con días de vacaciones suficientes. Favor ingresar fechas válidas.");
      return;
    }

    const nuevaSolicitud = {
      Usuario: usuario.Usuario,
      Correo: usuario.Correo,
      TipoSolicitud: tipo,
      FechaInicio: formatearFecha(fechaInicio),
      FechaFin: formatearFecha(fechaFin),
      Comentario: comentario,
      Estado: "Pendiente",
      FechaSolicitud: obtenerFechaHoy()
    };

    try {
      await axios.post(`${API}/solicitudes_rrhh`, nuevaSolicitud);
      alert("Solicitud enviada correctamente");
      obtenerSolicitudes(usuario.Usuario);
      setFechaInicio("");
      setFechaFin("");
      setComentario("");
      setPaginaActual(1);
    } catch (err) {
      console.error("Error al enviar solicitud:", err);
      alert("Hubo un error al enviar la solicitud");
    }
  };

  // Abrir selector de archivos
  const abrirSelectorArchivos = () => fileInputRef.current?.click();

  // Subir archivos seleccionados
  const handleSeleccionArchivos = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    try {
      setSubiendo(true);
      const form = new FormData();
      files.forEach(f => form.append("archivos", f));
      // Puedes enviar la carpeta en URL (como está aquí) y/o como campo:
      form.append("carpeta", rutaCarpeta);
      form.append("usuarioCodigo", usuario?.Usuario || ""); 

      await axios.post(`${API}/subir_documentos_usuario/${rutaCarpeta}`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // Refrescar lista
      const res = await axios.get(`${API}/documentos_usuario/${rutaCarpeta}`);
      if (res.data.exito) setDocumentos(res.data.documentos);
    } catch (err) {
      console.error("Error subiendo documentos:", err);
      alert("No se pudieron subir los documentos.");
    } finally {
      setSubiendo(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  // Abrir modal de confirmación para eliminar
  const pedirConfirmacionEliminar = (doc) => {
    setArchivoAEliminar(doc);
    setMostrarModalEliminar(true);
  };

  // Ejecutar eliminación
  const confirmarEliminar = async () => {
    if (!archivoAEliminar) return;
    try {
      setEliminando(true);
      await axios.delete(`${API}/eliminar_documento/${rutaCarpeta}/${encodeURIComponent(archivoAEliminar)}`);
      // Refrescar lista
      const res = await axios.get(`${API}/documentos_usuario/${rutaCarpeta}`);
      if (res.data.exito) setDocumentos(res.data.documentos);
    } catch (err) {
      console.error("Error eliminando documento:", err);
      alert("No se pudo eliminar el documento.");
    } finally {
      setEliminando(false);
      setMostrarModalEliminar(false);
      setArchivoAEliminar(null);
    }
  };
  return (
    <div className="container py-3">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold fs-4 text-center w-100">Mi Perfil</h2>
      </div>

      {/* PESTAÑAS ESTILO GESTIÓN DE USUARIOS */}
      <ul className="nav nav-tabs justify-content-center mb-4">
        <li className="nav-item">
          <button
            className={`nav-link ${pestanaActiva === "info" ? "active" : ""}`}
            onClick={() => setPestanaActiva("info")}
          >
            <i className="bi bi-person-circle me-2"></i>Datos Personales
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${pestanaActiva === "solicitudes" ? "active" : ""}`}
            onClick={() => setPestanaActiva("solicitudes")}
          >
            <i className="bi bi-journal-text me-2"></i>Mis Solicitudes
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${pestanaActiva === "documentos" ? "active" : ""}`}
            onClick={() => setPestanaActiva("documentos")}
          >
            <i className="bi bi-file-earmark-text me-2"></i>Documentos
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${pestanaActiva === "capacitaciones" ? "active" : ""}`}
            onClick={() => setPestanaActiva("capacitaciones")}
          >
            <i className="bi bi-mortarboard-fill me-2"></i>Capacitaciones
          </button>
        </li>
      </ul>

      {pestanaActiva === "info" && (
        <div className="card shadow-sm p-4">
          <h5 className="fw-bold mb-4 text-center">Información del Usuario</h5>
          {usuario ? (
            <>
              {/* FOTO + DATOS PERSONALES */}
              <div className="row align-items-center mb-4">
                {/* FOTO PERFIL */}
                <div className="col-md-3 text-center mb-3 mb-md-1">
                  <img
                    src={usuario.FotoPerfil || "/default-profile.png"}
                    alt="Foto de Perfil"
                    className="img-fluid rounded-circle shadow"
                    style={{ width: "150px", height: "150px", objectFit: "cover" }}
                  />
                </div>

                {/* DATOS PERSONALES */}
                <div className="col-md-9">
                  <h6 className="text-primary border-bottom pb-1">🧍 Datos Personales</h6>
                  <div className="row">
                    <div className="col-md-4 mt-2"><strong>Nombre:</strong> {usuario.Nombre}</div>
                    <div className="col-md-4 mt-2"><strong>Apellido Paterno:</strong> {usuario["Apellido Paterno"]}</div>
                    <div className="col-md-4 mt-2"><strong>Apellido Materno:</strong> {usuario["Apellido Materno"]}</div>
                    <div className="col-md-4 mt-2"><strong>Fecha de Nacimiento:</strong> {usuario["FechaNacimiento"]}</div>
                    <div className="col-md-4 mt-2"><strong>Cédula Identidad:</strong> {usuario.CedulaIdentidad || "---"}</div>
                    <div className="col-md-4 mt-2"><strong>Correo:</strong> {usuario.Correo}</div>
                  </div>
                </div>
              </div>

              {/* DATOS CORPORATIVOS */}
              <div className="mb-4">
                <h6 className="text-success border-bottom pb-1">🏢 Datos Corporativos</h6>
                <div className="row">
                  <div className="col-md-4 mt-2"><strong>Usuario:</strong> {usuario.Usuario}</div>
                  <div className="col-md-4 mt-2"><strong>Área / Departamento:</strong> {usuario["Área o Departamento"]}</div>
                  <div className="col-md-4 mt-2"><strong>Cargo:</strong> {usuario.Cargo || "---"}</div>
                  <div className="col-md-4 mt-2"><strong>Jefe Directo:</strong> {jefeDirecto}</div>
                  <div className="col-md-4 mt-2"><strong>Rol:</strong> {usuario.RolUsuario}</div>
                </div>
              </div>

              {/* FECHAS Y JORNADA */}
              <div className="mb-4">
                <h6 className="text-warning border-bottom pb-1">📅 Fechas y Jornada</h6>
                <div className="row">
                  <div className="col-md-4"><strong>Fecha de Ingreso:</strong> {usuario.FechaIngreso}</div>
                  <div className="col-md-4"><strong>Jornada Laboral:</strong> {usuario.JornadaLaboral}</div>
                  <div className="col-md-4">
                    <strong>Días de Vacaciones:</strong> {calcularVacaciones(usuario.FechaIngreso, solicitudes)} días
                  </div>
                </div>
              </div>
            </>
          ) : (
            <p>No se encontró información del usuario.</p>
          )}
        </div>
      )}


      {/* SOLICITUDES */}
      {pestanaActiva === "solicitudes" && (
        <>
          <div className="card shadow-sm mb-4">
            <div className="card-body">
              <h5 className="fw-bold mb-3">📬 Nueva Solicitud</h5>
              <form onSubmit={enviarSolicitud} className="border rounded p-3">
                <div className="row">
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Tipo de Solicitud</label>
                    <select
                      className="form-select"
                      value={tipo}
                      onChange={(e) => setTipo(e.target.value)}
                      required
                    >
                      <option value="">-- Selecciona tipo --</option>
                      {tiposSolicitud.map((tipoNombre, index) => (
                        <option key={index} value={tipoNombre}>
                          {tipoNombre}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Fecha Inicio</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fechaInicio}
                      onChange={(e) => setFechaInicio(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Fecha Fin</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fechaFin}
                      onChange={(e) => setFechaFin(e.target.value)}
                      required
                    />
                  </div>
                </div>

                {/* ✅ Fila horizontal para comentario + botón */}
                <div className="row align-items-end">
                  <div className="col-md-9">
                    <label className="form-label">Favor detallar solicitud</label>
                    <textarea
                      className="form-control"
                      rows={2}
                      value={comentario}
                      onChange={(e) => setComentario(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3 text-end mt-3">
                    <button type="submit" className="btn btn-primary w-50">
                      Enviar Solicitud
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="card shadow-sm">
            <div className="card-body">
              <h5 className="fw-bold mb-3">📌 Solicitudes Registradas</h5>
              <div style={{ minHeight: "350px" }}>
                <table className="table table-bordered table-striped text-center align-middle w-100">
                  <thead>
                    <tr>
                      <th>Fecha Solicitud</th>
                      <th>Tipo</th>
                      <th>Inicio</th>
                      <th>Fin</th>
                      <th>Días</th>
                      <th>Comentario</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {solicitudesPaginadas.map((s, i) => (
                      <tr key={i}>
                        <td>{s.FechaSolicitud || "—"}</td>
                        <td>{s.TipoSolicitud}</td>
                        <td>{s.FechaInicio}</td>
                        <td>{s.FechaFin}</td>
                        <td>{contarDiasHabiles(s.FechaInicio, s.FechaFin)}</td>
                        <td>{s.Comentario}</td>
                        <td>
                          <span
                            className={`badge ${
                              s.Estado === "Aprobado"
                                ? "bg-success"
                                : s.Estado === "Rechazado"
                                ? "bg-danger"
                                : "bg-warning text-dark"
                            }`}
                          >
                            {s.Estado}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {totalPaginas > 1 && (
                <div className="d-flex justify-content-center mt-1 gap-2">
                  <button
                    className="btn btn-outline-primary btn-sm"
                    disabled={paginaActual === 1}
                    onClick={() => setPaginaActual(paginaActual - 1)}
                  >
                    ← Anterior
                  </button>
                  <span className="align-self-center fw-bold">
                    Página {paginaActual} de {totalPaginas}
                  </span>
                  <button
                    className="btn btn-outline-primary btn-sm"
                    disabled={paginaActual === totalPaginas}
                    onClick={() => setPaginaActual(paginaActual + 1)}
                  >
                    Siguiente →
                  </button>
                </div>
              )}
              {solicitudes.length === 0 && (
                <p className="text-muted text-center">No hay solicitudes registradas.</p>
              )}
            </div>
          </div>
        </>
      )}

      {/* DOCUMENTOS */}
      {/* {pestanaActiva === "documentos" && (
        <div className="row">
          <div className="col-12">
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title fw-bold mb-3">Mis Documentos</h5>
                  {documentos.length === 0 ? (
                    <p className="text-muted">No hay documentos disponibles aún.</p>
                  ) : (
                    <ul className="list-group">
                      {documentos.map((doc, index) => (
                        <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                          {doc}
                          <a
                            href={`${API}/descargar_documento/${rutaCarpeta}/${doc}`}
                            className="btn btn-sm btn-outline-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Descargar
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
              </div>
            </div>
          </div>
        </div>
      )} */}

      {/* DOCUMENTOS */}
      {pestanaActiva === "documentos" && (
        <div className="row">
          <div className="col-12">
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title fw-bold mb-3 d-flex justify-content-between align-items-center">
                  <span>Mis Documentos</span>

                  <div>
                    <Button
                      size="sm"
                      variant="success"
                      onClick={abrirSelectorArchivos}
                      disabled={subiendo}
                    >
                      {subiendo ? "Subiendo..." : "Agregar documentos"}
                    </Button>

                    {/* input oculto */}
                    <input
                      ref={fileInputRef}
                      type="file"
                      multiple
                      onChange={handleSeleccionArchivos}
                      style={{ display: "none" }}
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                    />
                  </div>
                </h5>

                {documentos.length === 0 ? (
                  <p className="text-muted">No hay documentos disponibles aún.</p>
                ) : (
                  <ul className="list-group">
                    {documentos.map((doc, index) => (
                      <li
                        key={index}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        {doc}

                        <div className="d-flex align-items-center">
                          <a
                            href={`${API}/descargar_documento/${rutaCarpeta}/${doc}`}
                            className="btn btn-sm btn-outline-primary me-2"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Descargar
                          </a>

                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={() => pedirConfirmacionEliminar(doc)}
                          >
                            Eliminar
                          </Button>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>

          {/* Modal de confirmación para eliminar */}
          <Modal
            show={mostrarModalEliminar}
            onHide={() => setMostrarModalEliminar(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Eliminar documento</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ¿Desea eliminar el archivo <strong>{archivoAEliminar}</strong>?
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setMostrarModalEliminar(false)}>
                Cancelar
              </Button>
              <Button
                variant="danger"
                onClick={confirmarEliminar}
                disabled={eliminando}
              >
                {eliminando ? "Eliminando..." : "Eliminar"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}


      {/* CAPACITACIONES */}
      {pestanaActiva === "capacitaciones" && (
        <div className="row">
          <div className="col-12">
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title fw-bold mb-3">Mis Capacitaciones</h5>
                <p className="text-muted">Aquí verás el historial de cursos, talleres o formaciones que has realizado.</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MiPerfil;

